<template>
  <div :class="$style.skeleton_page">
    <div :class="$style.header">
      <div
        v-for="(item, index) in layout.header"
        :key="index"
        :class="{
          [$style.cell]: true,
          [$style.align_right]: index >= 3
        }"
        :style="{width: index === 0 ? firtsColumnWidth : item.width}"
      >
        <div :class="$style.skeleton_text" />
      </div>
    </div>
    <div
      ref="tableBody"
      :class="$style.body"
    >
      <div
        v-for="(row, rowIndex) in layout.rows"
        :key="rowIndex"
        :class="$style.row"
        :style="[7, 8].includes(rowIndex) ? {paddingTop: '34px'} : null"
      >
        <div
          v-for="(cell, cellIndex) in row"
          :key="cellIndex"
          :style="{width: cellIndex === 0 ? firtsColumnWidth : cell.width, padding: '8px'}"
          :class="$style.cell"
        >
          <div
            v-if="cell.items"
            :class="$style.items_wrapper"
            :style="[2, 3, 4, 5, 6].includes(rowIndex) && cellIndex === 0 ? {paddingLeft: '20px'} : null"
          >
            <div
              v-for="(item, itemIndex) in cell.items"
              :key="itemIndex"
              :style="{ width: cellIndex > 0 && [2, 3, 4, 5, 6].includes(rowIndex) ? columnWidth : '100%' }"
              :class="{
                [$style.item]: true,
                [$style.align_right]: cellIndex > 1
              }"
            >
              <div
                :class="$style.skeleton_text"
                :style="[
                  {width: item.width},
                  [2, 3, 4, 5, 6].includes(rowIndex) ? {height: '16px'} : null
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const columnWidth = 135;

export default {
  data() {
    return {
      layout: {
        header: [
          { width: 0 },
          { width: `${columnWidth}px` },
          { width: `${columnWidth}px` },
          { width: `${columnWidth}px` },
          { width: `${columnWidth}px` },
          { width: `${columnWidth}px` },
        ],
        rows: [
          [
            { width: 0 },
            { width: `${columnWidth * 3}px`, items: [{ width: '100%' }] }
          ],
          [
            { width: 0, items: [{ width: '154px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '100%' }] },
          ],
          [
            { width: 0, items: [{ width: '100%' }] },
            { width: `${columnWidth * 2}px`, items: [{ width: '108px' }, { width: '108px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '23px' }, { width: '25px' }, { width: '23px' }] },
          ],
          [
            { width: 0, items: [{ width: '151px' }] },
            { width: `${columnWidth * 2}px`, items: [{ width: '108px' }, { width: '108px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '33px' }, { width: '19px' }, { width: '25px' }] },
          ],
          [
            { width: 0, items: [{ width: '229px' }] },
            { width: `${columnWidth * 2}px`, items: [{ width: '108px' }, { width: '108px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '25px' }, { width: '23px' }, { width: '33px' }] },
          ],
          [
            { width: 0, items: [{ width: '170px' }] },
            { width: `${columnWidth * 2}px`, items: [{ width: '49px' }, { width: '49px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '25px' }, { width: '25px' }, { width: '19px' }] },
          ],
          [
            { width: 0, items: [{ width: '275px' }] },
            { width: `${columnWidth * 2}px`, items: [{ width: '108px' }, { width: '108px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '19px' }, { width: '33px' }, { width: '25px' }] },
          ],
          [
            { width: 0, items: [{ width: '161px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '100%' }] },
          ],
          [
            { width: 0, items: [{ width: '192px' }] },
            { width: `${columnWidth * 3}px`, items: [{ width: '100%' }] },
          ],
        ],
      },
    };
  },
  computed: {
    columnWidth() {
      return `${columnWidth}px`;
    },
    firtsColumnWidth() {
      const leftSidebarWidth = this.$store.getters.leftSidebarWidth;
      const width = document.documentElement.clientWidth - ((columnWidth * 5) + leftSidebarWidth + 32);

      return `${width}px`;
    },
  },
};
</script>

<style module lang="less">
 .skeleton_page {
  background: #F8F8F8;
  height: 100%;

  .header {
    height: 36px;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 16px;
    border-bottom: 1px solid #E5E5E5;

    .cell {
      display: flex;
      align-items: center;
      padding: 11px 12px;

      &:not(:last-child) {
        border-right: 1px solid #E5E5E5;
      }

      .skeleton_text {
        height: 14px;
        width: 77px;
      }
    }
  }

  .body {
    padding: 0 16px;

    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .cell {
        display: flex;
        align-items: center;

        .items_wrapper {
          display: flex;
          width: 100%;

          .item {
            display: flex;
            padding: 0 8px;
          }
        }
      }
    }
  }

  .align_right {
    justify-content: flex-end;
  }

  .skeleton_text {
    height: 20px;
    background: #F2F2F2;
    border-radius: 4px;
  }
 }
</style>
